import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent, BaseService } from '@core';
import { firstValueFrom } from 'rxjs';
import { Program, ProgramStartDateTypeEnum } from '@models';
import { StringFns, UtilFns } from '@utils';

export interface IProgramCycleParams {
  oldProgram?: Program;
  startDateType: ProgramStartDateTypeEnum;
}

export interface IProgramNewCycleData {
  newProgramName: string;
  newStartDate?: Date;
  newEndDate: Date;
}

@Component({
  selector: 'prox-program-cycle.dialog.component',
  standalone: false,
  templateUrl: './program-cycle.dialog.component.html',
})
export class ProgramCycleDialogComponent implements OnInit {
  oldProgram?: Program;
  newData: IProgramNewCycleData = {} as IProgramNewCycleData;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig<IProgramCycleParams>,
    private toastr: ToastrService,
    private pngDialogService: DialogService,
  ) {}
  async ngOnInit() {
    const params = this.config.data;
    UtilFns.assertNonNull(params);
    this.oldProgram = params.oldProgram;
    this.newData.newProgramName = <string>this.oldProgram?.name;
  }

  public static async openDialog(dialogService: DialogService, data?: IProgramCycleParams, config?: DynamicDialogConfig) {
    const ref = dialogService.open(ProgramCycleDialogComponent, {
      closable: false,
      draggable: true,
      width: '50vh',
      height: '65vh',
      maximizable: false,
      resizable: true,
      modal: true,
      // baseZIndex: 10000,
      focusOnShow: false,
      ...config,
      data: data,
    });
    const r = await firstValueFrom(ref.onClose);
    return r;
  }

  onProceed() {
    if (StringFns.isNullEmptyOrWhiteSpace(this.newData.newProgramName) || !this.newData.newStartDate || !this.newData.newEndDate) {
      this.toastr.warning('All fields must be completed', 'Cannot Proceed');
      return;
    }

    if (this.newData.newEndDate <= <Date>this.newData.newStartDate) {
      this.toastr.warning('Start date must precede end date', 'Cannot Proceed');
      return;
    }

    if (this.oldProgram?.endDate && <Date>this.newData.newStartDate <= <Date>this.oldProgram.endDate) {
      this.toastr.warning('New start date must follow the end date of the current program', 'Cannot Proceed');
      return;
    }

    this.ref.close(this.newData);
  }

  onCancel() {
    this.ref.close(null);
  }
}
